export const dashboardConstants = {
    DASHBOARD_FETCH_REQUEST: "DASHBOARD_FETCH_REQUEST",
    DASHBOARD_FETCH_SUCCESS: "DASHBOARD_FETCH_SUCCESS",
    DASHBOARD_FETCH_FAILURE: "DASHBOARD_FETCH_FAILURE",
};
